module.exports = __webpack_public_path__ + "static/media/upload-file-2.47bb2941.svg";